/// <amd-module name="Repos/Discussion/Editor/Widgets/InternalZoneWidget" />

export interface IZoneWidgetProps {
    isAccessible?: boolean;
    onFillContainer: (container: HTMLElement) => void;
    onLayout: (height: number, width: number) => void;
    onWidth: (width: number) => void;
    showArrow?: boolean;
    showFrame?: boolean;
}

export interface IZoneWidget {
    container: HTMLElement;
    domNode: HTMLElement;

    _doLayout: (heightInPixel: number, widthInPixel?: number) => void;
    _fillContainer: (container: HTMLElement) => void;
    _onWidth: (width: number) => void;
    _relayout: (newHeightInLines: number) => void;

    create: () => void;
    dispose: () => void;
    show: (position: monaco.Position, height: number) => void;
}

declare type ZoneWidgetType = new (editor: monaco.editor.ICodeEditor, props?: IZoneWidgetProps) => IZoneWidget;

function getZoneWidgetType(): ZoneWidgetType {
    const InternalZoneWidget = (window as any).LWL.req("monaco-editor").ZoneWidget;

    // There is no public API to work with zone widgets and we need to
    // override a few methods of the internal ZoneWidget class.
    // That's why we have this zone widget class to override some methods of it.
    //
    // Override methods are:
    //     - _doLayout
    //     - _fillContainer
    //
    // We need the keep other empty methods to comply with the IZoneWidget interface
    // which is the only exported type.
    class ZoneWidget extends InternalZoneWidget {
        private props: IZoneWidgetProps;

        public container: HTMLElement;
        public domNode: HTMLElement;

        constructor(editor: monaco.editor.ICodeEditor, props: IZoneWidgetProps) {
            super(editor, { ...props, showArrow: false, showFrame: false });
            this.props = props;
        }

        public create(): void {
            super.create();
        }

        public dispose(): void {
            super.dispose();
        }

        public show(position: monaco.Position, height: number): void {
            super.show(position, height);
        }

        public _doLayout(heightInPixel: number, widthInPixel: number): void {
            this.props.onLayout(heightInPixel, widthInPixel);
        }

        public _fillContainer(container: HTMLElement): void {
            this.props.onFillContainer(container);
        }

        public _onWidth(width: number): void {
            this.props.onWidth(width);
        }

        public _relayout(newHeightInLines: number): void {
            super._relayout(newHeightInLines);
        }
    }

    return ZoneWidget;
}

let ZoneWidget: ZoneWidgetType | undefined;

export function createZoneWidget(editor: monaco.editor.ICodeEditor, props?: IZoneWidgetProps): IZoneWidget {
    if (!ZoneWidget) {
        ZoneWidget = getZoneWidgetType();
    }

    return new ZoneWidget(editor, props);
}
